// extracted by mini-css-extract-plugin
export default {"products":"Du-z","card":"Eu-z","oosMessaging":"Fu-z"};